import { render } from "./AdminForm.vue?vue&type=template&id=454921ab"
import script from "./AdminForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdminForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script